import { createClient } from "@supabase/supabase-js";

// Public (publishable) credentials — same ones embedded in the mobile app.
// The service_role key lives ONLY on the backend server.
const SUPABASE_URL = "https://zroycvvhclkuaxusysgc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "sb_publishable_cbD4nTtJ99ZtYEkfH3Al7g_CThkXNHK";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
